import { Subject } from "rxjs";

// dialog subjects
export const openModal = new Subject();
export const closeModal = new Subject();

// drawer subjects
export const drawerOpen = new Subject();
export const drawerClose = new Subject();
export const drawerUpdate = new Subject();

export const loader = new Subject();
